import type { Project } from "@shared/types";

/**
 * Resolves a project's Firestore base path as a slash-separated string,
 * suitable for passing as the first path argument to `doc()` or
 * `collection()`:
 *
 *   doc(db, projectBasePath(p), "data", "budget-b")
 *   collection(db, projectBasePath(p), "aiReviews")
 *
 * Post-cutover: all projects live at the top-level `projects/{id}` path.
 */
export function projectBasePath(project: Pick<Project, "id">): string {
  return `projects/${project.id}`;
}

/**
 * Resolves a project's Cloud Storage base path (no trailing slash).
 * Used by every feature that uploads files (floorplans, attachments,
 * design items, space gallery, feedback).
 *
 *   `${projectStorageBasePath(p)}/floorplans/${id}.dwg`
 *   `${projectStorageBasePath(p)}/attachments/${budgetId}/${file}`
 */
export function projectStorageBasePath(project: Pick<Project, "id">): string {
  return `projects/${project.id}`;
}
